import { ReactNode } from 'react';
import { cn, QueryableComponent, Stack, StackProps } from '@prenuvo/halo';

import { SidePanelHeader } from './side-panel-header.component';
import { SidePanelOverlay } from './side-panel-overlay.component';

interface SidePanelProps extends QueryableComponent {
  ariaLabel: string;
  children: ReactNode;
  isOpen: boolean;
  onClose: () => void;
  showHeader?: boolean;
  title?: ReactNode;
  titleJustification?: StackProps['justification'];
}

export function SidePanel({
  ariaLabel,
  children,
  'data-testid': dataTestId = 'fct-side-panel',
  isOpen,
  onClose,
  showHeader = true,
  title,
  titleJustification = 'end',
}: SidePanelProps) {
  return (
    <Stack
      alignment="center"
      className="z-40 flex w-full"
      data-testid={dataTestId}
      justification="center"
      variant="vertical"
    >
      <SidePanelOverlay isOpen={isOpen}>
        <aside
          aria-label={ariaLabel}
          className={cn(
            'flex w-1/2 flex-col',
            'absolute right-0 h-[calc(100%-64px)] w-full bg-neutral-950 drop-shadow-2xl dark:bg-neutral-950',
            'transition-all duration-300 ease-out',
            {
              'translate-y-full md:translate-x-full md:translate-y-0': !isOpen,
            },
          )}
        >
          {showHeader ? (
            <SidePanelHeader
              onCloseClick={onClose}
              title={title}
              titleJustification={titleJustification}
            />
          ) : null}

          {children}
        </aside>
      </SidePanelOverlay>
    </Stack>
  );
}
